import { React, useEffect, useState } from "react";
import {
  userProfile,
  userNotification,
  updateProfile,
  changePassword,
} from "../../redux/actions"; // Import logout action type
import { toast } from "react-toastify";

const SelfserviceMePage = () => {
  //const user = useSelector((state) => state?.user_data?.user_data);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [pageData, setPageData] = useState(null);
  const [NotificationData, setNotificationData] = useState(null);
  // const [selectedCountry, setSelectedCountry] = useState("");
  // const [selectedChannel, setSelectedChannel] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [newshowPassword, setnewShowPassword] = useState(false);
  const [showCpPassword, setCpShowPassword] = useState(false);
  const [ShowPasswordForm, setShowPasswordForm] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    notification_via: "",
    email: "",
    phone_nr: "",
    area_code: "",
    id: "",
    notification: [], // Store checkboxes as an array
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await userProfile();
        if (result?.page?.data?.user) {
          setPageData(result.page.data.user);
        } else {
          setError("User data not found");
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
        setError("Error fetching page data");
      } finally {
        setLoading(false);
      }
    };

    const fetchNotifications = async () => {
      try {
        const result = await userNotification();
        if (result) {
          setNotificationData(result);
        } else {
          setError("User data not found");
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
        setError("Error fetching page data");
      } finally {
        setLoading(false);
      }
    };

    fetchData(); // Call the async function
    fetchNotifications(); // Call the async function
  }, []);

  useEffect(() => {
    if (pageData && NotificationData) {
      setFormData({
        name: pageData?.name ?? "",
        notification_via: pageData?.comm_channel ?? "email",
        email: pageData?.email ?? "",
        phone_number: pageData?.phone_nr ?? "",
        area_code: pageData?.phone_area_code ?? "",
        user_id: pageData?.id ?? "",
        notification: NotificationData,
      });
    }
  }, [pageData, NotificationData]); //pageData, NotificationData Runs when `pageData` or `NotificationData` updates

  // useEffect(() => {
  //   if (pageData?.phone_area_code) {
  //     setSelectedCountry(pageData.phone_area_code);
  //   }
  //   if (pageData?.comm_channel) {
  //     setSelectedChannel(pageData.comm_channel); // Auto-select based on pageData
  //   }
  // }, [pageData]);

  // Handle text input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Handle checkbox change
  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;

    setFormData((prev) => ({
      ...prev,
      notification: {
        ...prev.notification, // ✅ Spread existing values
        [name]: checked, // ✅ Set true/false instead of adding/removing from an array
      },
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name) {
      toast.error("Please enter the name!");
      return;
    }

    if (!formData.phone_number) {
      toast.error("Please enter the Phone no!");
      return;
    }

    const phno = formData.phone_number;
    if (typeof phno === "string" && phno.length !== 8 && phno.length !== 9) {
      toast.error("Phone number must be exactly 8 or 9 digits!");
      return;
    }

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      toast.error("Please enter a valid email address!");
      return;
    }

    if (!formData.notification_via) {
      toast.error("choose notification field!");
      return;
    }

    try {
      await updateProfile(formData);

      // const data = await response.json();

      toast.success("Profile updated successfully!");
    } catch (error) {
      toast.error("Error updating profile!");
    }
  };

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();

    if (
      !formData.password ||
      !formData.old_password ||
      !formData.password_confirmation
    ) {
      toast.error("All fields are required!");
      return;
    }
    const showErrors = (errors) => {
      Object.values(errors)
        .flat()
        .forEach((message) => {
          toast.error(message);
        });
    };

    try {
      const response = await changePassword(formData);
      console.log(response.status);
      if (response.status === 200) {
        toast.success("Password updated successfully!");
      } else {
        showErrors(response);
      }
      // const data = await response.json();
    } catch (error) {
      toast.error("Error updating password!");
    }
  };

  return (
    <section className="hot-deals pt-20">
      {/* component 1 about us*/}
      <form onSubmit={handleSubmit}>
        <div className="container container-lg">
          <div className="section-heading">
            <div className="d-flex align-items-center justify-content-between flex-wrap gap-8">
              {/* Heading on the right */}

              <h2 className="mb-0 text-blue">
                {ShowPasswordForm && (
                  <button
                    onClick={() => setShowPasswordForm(false)}
                    className="ph ph-arrow-left animated-caret w-52 h-52 bg-main-600 text-white text-xl hover-bg-main-600 hover-text-white flex-center"
                  ></button>
                )}
                &nbsp; <b>MY PERSONAL </b>PROFILE
              </h2>
              {/* Button on the left */}
              {!ShowPasswordForm && (
                <button
                  className="btn bg-main-product-50 hover-bg-main-product-50 hover-text-white"
                  type="submit"
                >
                  Save Changes
                </button>
              )}
              {/* {ShowPasswordForm && (
                <button
                  className="btn btn-primary"
                  type="button"
                  onClick={() => setShowPasswordForm(false)}
                >
                  Back
                </button>
              )} */}
            </div>
          </div>
        </div>
      </form>{" "}
      {!ShowPasswordForm && (
        <div className="container container-lg ">
          <div className="row gy-4">
            {/* grid for orders */}

            <div className="col-sm-6 ">
              <div className="border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2 offer-card position-relative overflow-hidden p-16">
                <div className="py-xl-4">
                  <h4 className="text-blue ack mb-8">Personal data</h4>
                  <hr></hr>
                  <div className="d-flex flex-column gap-3">
                    <div className="d-flex align-items-center gap-2">
                      <label
                        htmlFor="name"
                        className="lable-font font-heading-two text-gray-900 fw-semibold mb-0"
                        style={{ minWidth: "120px" }}
                      >
                        Name
                      </label>
                      <input
                        type="text"
                        className="input-font common-input px-16 flex-grow-1"
                        id="name"
                        name="name"
                        placeholder="Full name"
                        value={formData?.name ?? ""}
                        onChange={handleInputChange}
                      />
                    </div>
                    <hr></hr>
                    <div className="d-flex align-items-center gap-2">
                      <label
                        htmlFor="phone"
                        className="lable-font font-heading-two text-gray-900 fw-semibold mb-0"
                        style={{ minWidth: "120px" }}
                      >
                        Phone number
                      </label>

                      <div className="d-flex align-items-center gap-2 flex-grow-1">
                        <select
                          className="input-font common-input"
                          name="area_code"
                          id="phone_area_code"
                          style={{ width: "120px" }}
                          value={formData.area_code} // ✅ Uses formData
                          onChange={handleInputChange} // ✅ Updates formData
                        >
                          <option value="+968">+968</option>
                          <option value="+971">+971</option>
                          <option value="+974">+974</option>
                        </select>

                        <input
                          type="text"
                          className="input-font common-input flex-grow-1 px-16"
                          id="phone"
                          name="phone_number"
                          placeholder="Enter phone number"
                          value={formData?.phone_number ?? ""}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>

                    <hr></hr>
                    <div className="d-flex align-items-center gap-2">
                      <label
                        htmlFor="email"
                        className="lable-font font-heading-two text-gray-900 fw-semibold mb-0"
                        style={{ minWidth: "120px" }}
                      >
                        Email Address
                      </label>
                      <input
                        type="email"
                        className="input-font common-input px-16 flex-grow-1"
                        id="email"
                        name="email"
                        placeholder="Email address"
                        value={formData?.email ?? ""}
                        onChange={handleInputChange}
                      />
                      <input
                        type="hidden"
                        name="user_id"
                        value={formData?.id ?? ""}
                      />
                    </div>
                    <hr></hr>
                    <div className="d-flex align-items-center gap-2">
                      {/* Label */}
                      <label
                        htmlFor="lable-font notification"
                        className=" font-heading-two text-gray-900 fw-semibold mb-0"
                        style={{ minWidth: "120px" }}
                      >
                        Notifications via
                      </label>

                      {/* Radio Buttons in Same Line */}
                      <div className="d-flex align-items-center gap-12">
                        <div className="common-check common-radio mb-0">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="notification_via"
                            id="emailNotification"
                            value="email"
                            checked={formData?.notification_via === "email"} // ✅ Ensures correct selection
                            onChange={handleInputChange} // ✅ Updates formData
                          />
                          <label
                            className="lable-font form-check-label"
                            htmlFor="emailNotification"
                          >
                            Email
                          </label>
                        </div>

                        <div className="common-check common-radio mb-0">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="notification_via"
                            id="whatsappNotification"
                            value="whatsapp"
                            checked={formData?.notification_via === "whatsapp"}
                            onChange={handleInputChange}
                          />
                          <label
                            className="lable-font form-check-label"
                            htmlFor="whatsappNotification"
                          >
                            WhatsApp
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* grid for savings */}
            <div className="col-sm-6 ">
              <div className="border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2 offer-card position-relative overflow-hidden p-16">
                <div className="py-xl-4">
                  <h4 className="text-blue mb-8">Notifications</h4>
                  <hr></hr>
                  <div>
                    <div className="payment-item">
                      <div className="form-check common-check common-checkbox mb-0">
                        <input
                          className="input-font form-check-input"
                          type="checkbox"
                          name="delivery_info"
                          id="delivery_info"
                          checked={
                            formData.notification?.delivery_info ?? false
                          }
                          onChange={handleCheckboxChange}
                        />
                        <label
                          className="lable-font form-check-label fw-semibold text-neutral-600"
                          htmlFor="payment2"
                        >
                          Delivery info
                        </label>
                      </div>
                      <hr></hr>
                      <div className="form-check common-check common-checkbox  mb-0">
                        <input
                          className="input-font form-check-input"
                          type="checkbox"
                          name="credit_limit"
                          id="credit_limit"
                          checked={formData.notification?.credit_limit ?? false}
                          onChange={handleCheckboxChange}
                        />
                        <label
                          className="lable-font form-check-label fw-semibold text-neutral-600"
                          htmlFor="payment2"
                        >
                          You are about to reach your credit limit
                        </label>
                      </div>
                      <hr></hr>
                      <div className="form-check common-check common-checkbox  mb-0">
                        <input
                          className="input-font form-check-input"
                          type="checkbox"
                          name="local_user_orders"
                          id="local_user_orders"
                          checked={
                            formData.notification?.local_user_orders ?? false
                          }
                          onChange={handleCheckboxChange}
                        />
                        <label
                          className="lable-font form-check-label fw-semibold text-neutral-600"
                          htmlFor="payment2"
                        >
                          Local user has not placed order
                        </label>
                      </div>
                      <hr></hr>
                      <div className="form-check common-check common-checkbox  mb-0">
                        <input
                          className="input-font form-check-input"
                          type="checkbox"
                          name="local_user_order_different"
                          id="local_user_order_different"
                          checked={
                            formData.notification?.local_user_order_different ??
                            false
                          }
                          onChange={handleCheckboxChange}
                        />
                        <label
                          className="lable-font form-check-label fw-semibold text-neutral-600"
                          htmlFor="payment2"
                        >
                          Local user order out of ordinary
                        </label>
                      </div>
                      <hr></hr>
                      <div className="form-check common-check common-checkbox  mb-0">
                        <input
                          className="input-font form-check-input"
                          type="checkbox"
                          name="recurring_order"
                          id="recurring_order"
                          checked={
                            formData.notification?.recurring_order ?? false
                          }
                          onChange={handleCheckboxChange}
                        />
                        <label
                          className="lable-font form-check-label fw-semibold text-neutral-600"
                          htmlFor="payment2"
                        >
                          Recurring order reminder
                        </label>
                      </div>
                      <hr></hr>
                      <div className="form-check common-check common-checkbox  mb-0">
                        <input
                          className="input-font form-check-input"
                          type="checkbox"
                          name="productivity_tips"
                          id="productivity_tips"
                          checked={
                            formData.notification?.productivity_tips ?? false
                          }
                          onChange={handleCheckboxChange}
                        />
                        <label
                          className="lable-font form-check-label fw-semibold text-neutral-600"
                          htmlFor="payment2"
                        >
                          Productivity tips
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* grid for componants */}
            <div className="col-sm-6 ">
              <div className="border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2 offer-card position-relative overflow-hidden p-16">
                <div className="py-xl-4">
                  <h4 className="text-blue mb-8">Login data</h4>

                  <div className="col-xxl-6 col-lg-8 col-md-10 col-sm-12">
                    <div className="p-16 p-lg-24 rounded-16 bg-white w-100">
                      <div className="short-product-list">
                        {/* Email + Change Password */}
                        <div className="row mb-16 align-items-center">
                          <div className="col-sm-6">
                            <h6
                              className="mb-0 text-dark text-md"
                              style={{ whiteSpace: "nowrap" }}
                            >
                              Email and password
                            </h6>
                          </div>
                          <div className="col-sm-6">
                            <button
                              className="btn bg-main-product-50 hover-bg-main-product-50 hover-text-white text-nowrap"
                              type="button"
                              onClick={() => setShowPasswordForm(true)}
                            >
                              Change Password
                            </button>
                          </div>
                        </div>
                        <hr />

                        {/* Role */}
                        <div className="row align-items-center">
                          <div className="col-sm-6">
                            <h6
                              className="mb-0 text-dark text-md"
                              style={{ whiteSpace: "nowrap" }}
                            >
                              My role
                            </h6>
                          </div>
                          <div className="col-sm-6">
                            <span className="text-blue fw-semibold d-block">
                              {pageData?.is_admin === "true" ||
                              pageData?.is_admin === true
                                ? "Administrator"
                                : ""}
                            </span>
                          </div>
                        </div>
                        <hr />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>{" "}
        </div>
      )}
      {ShowPasswordForm && (
        <div className="container container-lg">
          <form onSubmit={handlePasswordSubmit}>
            <div className="section-heading">
              <div className="d-flex align-items-center justify-content-between flex-wrap gap-8">
                {/* Heading on the right */}
                <h5 className="mb-0 text-blue">Change Password</h5>
                {/* Button on the left */}
                <button
                  className="btn bg-main-product-50 hover-bg-main-product-50 hover-text-white text-nowrap"
                  type="submit"
                >
                  Update Password
                </button>
              </div>
            </div>
          </form>
          <div className="col-sm-6 ">
            <div className="border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2 offer-card position-relative overflow-hidden p-16">
              <div className="py-xl-4">
                {/* <h4 className="text-blue ack mb-8"></h4> */}
                <div className="d-flex flex-column gap-3">
                  <div className="d-flex align-items-center gap-2">
                    <label
                      htmlFor="name"
                      className="lable-font font-heading-two text-gray-900 fw-semibold mb-0"
                      style={{ minWidth: "120px" }}
                    >
                      Current Password
                    </label>
                    <input
                      type={showPassword ? "text" : "password"}
                      className="input-font common-input px-16 flex-grow-1"
                      id="old_password"
                      name="old_password"
                      placeholder="Old Password"
                      onChange={handleInputChange}
                    />{" "}
                    <button
                      type="button"
                      className="absolute right-2 top-1/2 transform -translate-y-1/2 text-lg"
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      {showPassword ? "🔒" : "👁️"}
                    </button>
                    <input
                      type="hidden"
                      className="common-input px-16 flex-grow-1"
                      id="email"
                      name="email"
                      placeholder="Email address"
                      onChange={handleInputChange}
                    />
                  </div>
                  <hr></hr>
                  <div className="d-flex align-items-center gap-2">
                    <label
                      htmlFor="phone"
                      className="lable-font font-heading-two text-gray-900 fw-semibold mb-0"
                      style={{ minWidth: "120px" }}
                    >
                      New Password
                    </label>
                    <input
                      type={newshowPassword ? "text" : "password"}
                      className="input-font common-input px-16 flex-grow-1"
                      id="password"
                      name="password"
                      placeholder="New Password"
                      onChange={handleInputChange}
                    />{" "}
                    <button
                      type="button"
                      className="absolute right-2 top-1/2 transform -translate-y-1/2 text-lg"
                      onClick={() => setnewShowPassword(!newshowPassword)}
                    >
                      {newshowPassword ? "🔒" : "👁️"}
                    </button>
                  </div>

                  <hr></hr>
                  <div className="d-flex align-items-center gap-2">
                    <label
                      htmlFor="email"
                      className="lable-font font-heading-two text-gray-900 fw-semibold mb-0"
                      style={{ minWidth: "120px" }}
                    >
                      Confirm password
                    </label>
                    <input
                      type={showCpPassword ? "text" : "password"}
                      className="input-font common-input px-16 flex-grow-1"
                      id="password_confirmation"
                      name="password_confirmation"
                      placeholder="Confirm password"
                      onChange={handleInputChange}
                    />{" "}
                    <button
                      type="button"
                      className="absolute right-2 top-1/2 transform -translate-y-1/2 text-lg"
                      onClick={() => setCpShowPassword(!showCpPassword)}
                    >
                      {showCpPassword ? "🔒" : "👁️"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default SelfserviceMePage;
